"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabelasVersao = void 0;
var TabelasVersao = /** @class */ (function () {
    function TabelasVersao() {
        (this.dadosResumido = 'dadosResumido'), (this.dadosSkuCalculado = 'dadosSkuCalculado');
    }
    return TabelasVersao;
}());
exports.TabelasVersao = TabelasVersao;
//# sourceMappingURL=TabelasVersao.js.map